import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { ApiClientSettingEffects } from './api-client-setting.effects';
import { apiClientSettingReducer } from './api-client-setting.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('apiClientSetting', apiClientSettingReducer),
    EffectsModule.forFeature([ApiClientSettingEffects]),
  ],
  providers: [],
})
export class ApiClientSettingStoreModule {}
